import { render, staticRenderFns } from "./ProductConfigIframe.vue?vue&type=template&id=500a5919&"
import script from "./ProductConfigIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductConfigIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports